import { Close, Delete } from "@payping/icons";
import { deleteClientClient, getClientClientList } from "@payping/redux/actions";
import { submitQueryParams } from "@payping/utils/query-string";
import { Button, Drawer, Modal, Space, Table, TableAction, useMessagedAsyncRetry } from "@payping/web-components";
import { ColumnsType } from "@payping/web-components/components/Table/types";
import qs from "query-string";
import React, { ReactElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { DashboardRoutes } from "@/router/constant";

interface ClientType {
  clientName?: string;
  clientId?: string;
  description?: string;
}

interface ListQueryParamsType {
  pageNumber?: number;
  pageSize?: number;
}
const MobileProfileClient: React.FC = () => {
  const { profile } = DashboardRoutes;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const search: ListQueryParamsType = qs.parse(location.search, { parseNumbers: true });
  const parsedSearch = {
    ...search,
    pageNumber: search.pageNumber || 1,
    pageSize: search.pageSize || 10,
  };
  const { pageSize, pageNumber } = parsedSearch;
  const clients = useAppSelector((state) => state.client.client);
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const [modal, contextHolder] = Modal.useModal();

  const { loading, retry } = useMessagedAsyncRetry(() => dispatch(getClientClientList()), [], { useProgress: true });

  const data = clients.list.map((client, index) => ({
    code: client.clientId,
    description: client.description,
    key: index,
    name: client.clientName,
  }));

  function handleDelete(rowIndex: number) {
    modal.confirm({
      cancelText: t("cancel"),
      content: t("client.remove"),
      okText: t("ok"),
      onOk: async () => {
        await dispatch(deleteClientClient(data[rowIndex].code as string));
      },
    });
  }

  const actions = (rowIndex: number): ReactElement[] => [
    <a key={0}>
      <TableAction
        Icon={Delete}
        iconColor={"danger"}
        label={t("delete")}
        onClick={() => {
          handleDelete(rowIndex);
        }}
        key={1}
      />
    </a>,
  ];

  const cols: ColumnsType<ClientType> = [
    {
      dataIndex: "name",
      ellipsis: true,
      key: "name",
      title: t("client.table.name"),
    },
    { dataIndex: "description", key: "description", title: t("client.table.description") },
  ];

  return (
    <Drawer
      open
      title={t("profile.accesses")}
      height={"100%"}
      placement={"bottom"}
      closeIcon={false}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(profile.mRoot.url);
          }}
        />
      }
    >
      <Space direction={"vertical"} size={"middle"} className={"tw-w-full"}>
        <Table<ClientType>
          loading={!data.length ? loading : false}
          hasIdColumn
          actions={actions}
          dataSource={data}
          columns={cols}
          pagination={{
            onChange: (page, newSize): void => {
              const newValues = {
                ...parsedSearch,
                pageNumber: page,
                pageSize: newSize,
              };
              submitQueryParams({
                navigate,
                newValues,
                parsedSearch,
                pathname: location.pathname,
                retry,
              });
            },
            onShowSizeChange: (_currentPage, newSize): void => {
              const newValues = {
                ...parsedSearch,
                pageNumber: 1,
                pageSize: newSize,
              };
              submitQueryParams({
                navigate,
                newValues,
                parsedSearch,
                pathname: location.pathname,
                retry,
              });
            },
            pageNumber,
            pageSize,
            showTotal: (total, range): string =>
              t("client.table.showTotal", { range: `${range[0]}-${range[1]}`, total }),
            total: clients.totalCount,
          }}
        />
        {contextHolder}
      </Space>
    </Drawer>
  );
};

export default MobileProfileClient;
